module.exports = __webpack_public_path__ + "img/SMARTPAY1.d9e64945.svg";